// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_10-1";
export var movingGradient = "_10-4";
export var movingGradientBlock = "_10-2";
export var skeleton = "_10-0";
export var skeletonText = "_10-3";